module.exports = __webpack_public_path__ + "static/media/project-30y_hacks.78e232bd.png";